

import { useNavigate } from "react-router-dom";
import Button from "../Button/Button";
import Card from "../Card/Card";
import aus from "../../assets/images/aus.png";
import usa from "../../assets/images/usa.png";
import { useEffect, useState } from "react";
import axios from "axios";
import FiveBundleImages from "../../assets/images/allbooks.png";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const IMAGE_BASE_URL = "https://kitehawk-api.onrender.com/image/";

export default function OurPopularCourses() {
  const [selected, setSelected] = useState([]);
  const [courses, setCourses] = useState([]);
  const [selectingCard, setselectingCard] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchCourses();
  }, []);

const fetchCourses = async () => {
  try {
    const token = localStorage.getItem("userToken");

    const { data } = await axios.get(`${BASE_URL}/api/getallcourse`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
      },
    });

     const sortedCourses = [...(data?.data || [])].reverse();

    //  console.log("ORIGINAL =>", data?.data);
    // console.log("FIXED ORDER =>", sortedCourses);

    setCourses(data.data);
    // setCourses(sortedCourses);
  } catch (error) {
    console.log("Get courses error:", error?.response?.data || error.message);
  }
};

const usaCourses = courses.filter((item) => item.flag === "usa");
  const austCourses = courses.filter((item) => item.flag === "aust");

  const handleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id],
    );
  };

  const handlefourselect = () => {
    setselectingCard(!selectingCard);
    alert();
  };

  const handleProceed = () => {
    const token = localStorage.getItem("userToken");

    if (!token) {
      alert("Please login to continue purchase");
      return;
    }

    if (selected.length === 0) {
      alert("Please select at least one course");
      return;
    }

     const selectedCourses = selected.map((id) => {
      const course = courses.find((c) => c._id === id);
      return {
        id: course._id,
        name: course.coursename,
        price: course.courseprice,
      };
    });

    navigate("/checkout", {
      state: { courses: selectedCourses },
    });
  };

  return (
    <div id="popular-courses" className="space-y-5">
      <h1 className="text-center font-bold text-lg lg:text-4xl mb-5">
        Our Popular Online Programs
      </h1>

<div className="coursesBgImage py-10 text-center">
  {/* USA Section */}
  <div className="container mx-auto px-6 lg:px-8">
    <h2 className="text-center font-bold text-md lg:text-3xl mb-5">
      USA Online Programs
    </h2>

    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mb-12">
      {/* USA Courses */}
      {usaCourses.map((item, index) => (
          <Card
            key={item._id}
            flag={item.flag}
            title={
              <div className="flex items-center justify-center gap-2">
                <span>{item.coursename}</span>
              </div>
            }
            // image={`${IMAGE_BASE_URL}${item.courseimage}`}
            image={item.courseimage?.startsWith("http") ? item.courseimage : `${IMAGE_BASE_URL}${item.courseimage}`}
            imageClassName="w-48 h-48 object-contain"
             onSelect={() => handleSelect(item._id)}
            selected={selected.includes(item._id)}
            selectable
          />
        ))}

      {/* USA Bundle */}
      {/* <Card
        flag="usa"
        title="USA Program Bundle"
        image={FiveBundleImages}
        imageClassName="w-48 h-48 object-contain"
        selectable={false}
      /> */}
    </div>

    {/* AUS Section */}
    <h2 className="text-center font-bold text-md lg:text-3xl mb-5">
      Australian - NZ Online Programs
    </h2>

    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
      {/* AUS Courses */}
      {austCourses.map((item, index) => (
          <Card
            key={item._id}
            flag={item.flag}
            title={
              <div className="flex items-center justify-center gap-2">
                <span>{item.coursename}</span>
              </div>
            }
            // image={`${IMAGE_BASE_URL}${item.courseimage}`}
            image={item.courseimage?.startsWith("http") ? item.courseimage : `${IMAGE_BASE_URL}${item.courseimage}`}
            imageClassName="w-48 h-48 object-contain"
             onSelect={() => handleSelect(item._id)}
            selected={selected.includes(item._id)}
            selectable
          />
        ))}

      {/* AUS Bundle */}
      {/* <Card
        flag="aust"
        title="Aus/NZ Program Bundle"
        image={FiveBundleImages}
        imageClassName="w-48 h-48 object-contain"
        selectable={false}
      /> */}
    </div>

    <Button className="mt-10" text="Proceed Now" onClick={handleProceed} showDivider />
  </div>
</div>
    </div>
  );
}
